import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { fetchCmsItems, getOptimizedImageUrl } from '../lib/cms'

export default function HotelsPage() {
  const [hotels, setHotels] = useState([])

  useEffect(() => {
    document.title = 'Hoteller & Indkvartering - SKI & CO TRAVEL ApS'
    async function loadHotels() {
      const data = await fetchCmsItems('hoteller')
      setHotels(data)
    }
    loadHotels()
  }, [])

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 space-y-10">
      <div className="space-y-3">
        <span className="text-xs font-bold uppercase tracking-widest text-cyan-400">
          SKI & CO TRAVEL ApS
        </span>
        <h1 className="font-heading font-extrabold text-2xl sm:text-4xl text-white">
          Håndplukkede Hoteller & Indkvartering
        </h1>
        <p className="text-slate-300 text-sm sm:text-base max-w-2xl leading-relaxed">
          Vi samarbejder med udvalgte hoteller, alpechalets og lejligheder med perfekt beliggenhed tæt på lifterne og høj komfort.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {hotels.map((hotel) => {
          const imageUrl = Array.isArray(hotel.hovedbillede)
            ? hotel.hovedbillede[0]
            : hotel.hovedbillede
          const slug = hotel.url_slug || hotel.slug?._ || hotel.id

          return (
            <div
              key={hotel.id}
              className="bg-slate-900 border border-slate-800 rounded-2xl overflow-hidden flex flex-col hover:border-slate-700 transition-all shadow-xl group"
            >
              <div className="relative h-56 overflow-hidden">
                <img
                  src={getOptimizedImageUrl(imageUrl, 600, 80)}
                  alt={hotel.hotelnavn}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/20 to-transparent" />
                <span className="absolute top-3 left-3 bg-slate-950/80 backdrop-blur-md text-cyan-300 text-xs font-semibold px-2.5 py-1 rounded-lg border border-slate-700">
                  {hotel.destination}
                </span>
              </div>

              <div className="p-6 flex-1 flex flex-col justify-between space-y-4">
                <div className="space-y-2">
                  <h3 className="font-heading font-bold text-xl text-white group-hover:text-cyan-300 transition-colors">
                    {hotel.hotelnavn}
                  </h3>
                  {hotel.placering && (
                    <div className="text-xs text-slate-400 flex items-center gap-1.5">
                      <i className="fa-solid fa-location-dot text-cyan-400" aria-hidden="true" />
                      <span>{hotel.placering}</span>
                    </div>
                  )}
                  {hotel.faciliteter && (
                    <p className="text-xs text-slate-300 line-clamp-2 pt-1">
                      {hotel.faciliteter}
                    </p>
                  )}
                </div>

                <Link
                  to={`/hoteller/${slug}`}
                  className="w-full py-2.5 rounded-xl bg-slate-800 hover:bg-cyan-500 hover:text-slate-950 text-white font-bold text-xs uppercase tracking-wider text-center transition-colors block border border-slate-700"
                >
                  Se hotel & faciliteter
                </Link>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
